import { BrokeragePostResponse } from '@lio/api-types';
import { brokerageKeys } from '@services/brokerage';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useUpdateBrokerage = (brokerageId: string | undefined) => {
  const client = useClient();
  const queryClient = useQueryClient();
  const mutationFn = ({
    osProducerUsername,
    entityStatus,
    restrictQuoteAccessToProducer,
  }: {
    osProducerUsername?: string;
    entityStatus?: string;
    restrictQuoteAccessToProducer?: boolean;
  }) =>
    client
      .patch(`brokerage/${brokerageId}`, {
        json: { osProducerUsername, entityStatus, restrictQuoteAccessToProducer },
      })
      .json<BrokeragePostResponse>();

  const result = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...brokerageKeys.brokerage, { brokerageId }] });
      queryClient.invalidateQueries({ queryKey: brokerageKeys.search });
    },
  });

  return { ...result, updateBrokerage: result.mutateAsync };
};
